import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AppState} from '../../../store';
import {toggleIsLoadingAction, updateSRPBusData,updateGoSafeBanner,toggleAlternateRoutePage,setNextDayPopup} from './../redux/actions';
import {prepareSRPApiRequest_V4,prepareGoSafeBannerURL, prepareLogFeMetricRequest} from './../Api';
import {ISRPBusData, IOperatorsData, IBusData} from './validation';
import megatron from '@stencil/megatron';
import {updateJourneyParams} from './../../Common/redux/actions';
import {formatString,getFilterHash} from './../Utils';
import querystring from 'query-string';
import {getIconName} from './../../Common/config'
import {pushga} from 'ga-utils';
import {SrpGAEvents} from './../../../config/ga-config';
import getDateObj from './../../../utils/GetDateObj'
import dateformat from 'dateformat';
import axios from 'axios';
import uuid from 'react-uuid';

  
export const fetchSrpDataThunk = (props): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleIsLoadingAction(true));
   // dispatch(toggleAlternateRoutePage(false))
    const state = getState();
    const journeyType:string = state['srp']['journeyType'];
    const sortBy = state['srp']['sortBy'];
    const{src,dest,src_id,dest_id,doj,src_name,dest_name, srcLat = '',  srcLon = '', destLat = '', destLon=''} = props;
  const url_v4 = prepareSRPApiRequest_V4();
  const device_id = uuid()
  sessionStorage.setItem('device_id', device_id)
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
  if(device_id){
    headers['device-id'] = device_id
  }
  try{ 
    const data = await megatron({
      name: 'Bus Search',
      type: 'POST',
      url:url_v4,
      requestData: querystring.stringify({src_vid:src_id,dest_vid:dest_id,doj,src:src_name,dest:dest_name}),
      credentials: 'include',
      headers: headers,
    });
   
 
         const year = doj.substring(0,4);
         const month = doj.substring(4,6);
         const day  = doj.substring(6,8);
         let selectedDate =getDateObj(`${year}-${month}-${day}`)
          dispatch(updateJourneyParams({
          src,
          dest,
          src_vid: src_id,
          dest_vid:dest_id,
          doj,
          journeyType: journeyType,
          flavour: 'dweb',
          dojObj: selectedDate,
          src_name,
          dest_name,
          srcLat,
          srcLon,
          destLat,
          destLon
        }))
       
  if(data && Object.keys(data).length && data.buses){
    
    const {buses,operators,popular_filters,bp_dict,dp_dict,route_logic,ps,alternate_route_data,next_day_bus, filter_cards} = data as ISRPBusData;
         const {
            rtcBuses,
            privateAvailableBuses,
            privateSoldOutBuses,
            dpList,
            bpList,
            amenities,
            operatorsList,
            popularFilters,
            isRouteEnable,
            single_seat
          } = getCategoryData(operators, buses, journeyType,popular_filters,bp_dict,dp_dict,src_id,dest_id,route_logic);

          dispatch(
            updateSRPBusData({
              data,
              rtcBuses,
              privateAvailableBuses,
              privateSoldOutBuses,
              dpList,
              bpList,
              operatorsList,
              amenities,
              popularFilters,
              isRouteEnable,
              ps,
              alternate_route_data,
              next_day_bus,
              filter_cards,
              single_seat
            }),
          );
       if(!data.buses.length && data.alternate_route_data && data.alternate_route_data.length){
          dispatch(toggleAlternateRoutePage(true))
          
        }else if(data.next_day_bus && data.next_day_bus.no_of_bus && data.next_day_bus.no_of_bus > 0){
          dispatch(setNextDayPopup(true));

          
         
       
        }
          dispatch(sortBusData(sortBy));
          pushga({
            event: SrpGAEvents.actions.bus_SRP_load.val,
            eventCategory: SrpGAEvents.category,
            eventAction: SrpGAEvents.actions.bus_SRP_load.val,
            eventLabel: data.buses.length ? SrpGAEvents.actions.bus_SRP_load.labels.success : SrpGAEvents.actions.bus_SRP_load.labels.deadend
          });
          
  }
}catch(err){
  dispatch(toggleIsLoadingAction(false));

  dispatch(
    updateSRPBusData({
      data:{},
      rtcBuses:{},
      privateAvailableBuses:{},
      privateSoldOutBuses:{},
      dpList:{},
      bpList:{},
      operatorsList:{},
      amenities:{},
      popularFilters:[],
      isRouteEnable:false,
      ps :''
    }),
  );
  console.trace(err);
  pushga({
    event: SrpGAEvents.actions.bus_SRP_load.val,
    eventCategory: SrpGAEvents.category,
    eventAction: SrpGAEvents.actions.bus_SRP_load.val,
    eventLabel:SrpGAEvents.actions.bus_SRP_load.labels.failure
  });

}
finally{
  dispatch(toggleIsLoadingAction(false));
    
}
};
}

export const sortBusData = (sortBy: string): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    const srpState = state['srp'];
    const journeyType = srpState['journeyType'];
    let busesAvailable = srpState.privateAvailableBuses[journeyType] || [];
    let soldOutBuses = srpState.privateSoldOutBuses[journeyType] || [];
    let rtcBuses = srpState.rtcBuses;
    busesAvailable.sort(busSortComparator({sortType: sortBy}));
    soldOutBuses.sort(busSortComparator({sortType: sortBy}));
    if (rtcBuses && Object.keys(rtcBuses).length) {
      Object.keys(rtcBuses).forEach(key => {
        rtcBuses[key][journeyType].availableBuses.sort(busSortComparator({sortType: sortBy}));
        rtcBuses[key][journeyType].soldOutBuses.sort(busSortComparator({sortType: sortBy}));
      });
    }
  };
};
export const checkSlPosition = (type: string): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    const state = getState();
    const srpState = state['srp'];
    const journeyType = srpState['journeyType'];
    let busesAvailable = srpState.privateAvailableBuses[journeyType] || [];
   
    busesAvailable?.forEach((bus, ind) => {
     if(bus?.adInventoryData !== null && (type==='onLoad' || type === 'best')){
      const temp = busesAvailable[3];
      busesAvailable[3] = bus;
      busesAvailable[ind] = temp;
      bus.adInventoryData.showAsAd = true
     }
     else if(bus?.adInventoryData !== null && type==='sorting'){

        if(ind > 3){
          bus.adInventoryData.showAsAd = false
        }else{
          bus.adInventoryData.showAsAd = true
        }
     }

    })
  };
};

export async function triggerSl(adInventoryData, type: string) {
  const { attributionChannel, headers } = adInventoryData
  const parsedHeaders = JSON.parse(headers)

  const clickAttributeUrl = attributionChannel.find((item: any) => item.type === type)?.url ?? ''
  // const trackingHeaders = getTrackingHeaders()

  try {
    const response = await axios.get(clickAttributeUrl, {
      headers: { ...parsedHeaders }
    })
    sessionStorage.setItem(type, clickAttributeUrl)
  } catch (error) {
    // Handle the error
    console.error(error)
  }
}

export async function triggerBo(boAdsData, type: string) {
  const {  headers, viewUrl, clickUrl } = boAdsData
  const clickAttributeUrl = type === 'BO_AD_VIEW' ? viewUrl : clickUrl
  // const trackingHeaders = getTrackingHeaders()
  let requestData = {}
  if(headers){
    requestData['headers'] = JSON.stringify(headers)
  }
  try {
    const response = await axios.get(clickAttributeUrl, requestData)
    sessionStorage.setItem(type, clickAttributeUrl)
    // if(response.status === 200 || response.statusText === 'OK') sessionStorage.setItem(type, clickAttributeUrl)
  } catch (error) {
    // Handle the error
    console.error(error)
  }
}

export async function logFeMetric(feMetricData) {
  const {  headers, body } = feMetricData
  let url = prepareLogFeMetricRequest()
  let requestHeaders = headers
  let requestBody = JSON.stringify(body)
  try {
    const response = await axios.post(url, requestBody, {headers: requestHeaders})
    if(response?.data?.error){
      throw new Error(response?.data?.error)
    }
    return response?.data?.messgae
  } catch (error) {
    // Handle the error
    console.error(error)
  }
}


//TODO add the return type validation
function getCategoryData(operators: IOperatorsData[], buses: IBusData[], journeyType: string,popular_filters:any,bp_dict:any,dp_dict:any,src_id:any,dest_id:any,route_logic?:string[]) {
  let rtcBuses = {};
  let privateAvailableBuses = {onw: [], ret: []};
  let privateSoldOutBuses = {onw: [], ret: []};
  const bpList = {onw: [], ret: []};
  const dpList = {onw: [], ret: []};
  let operatorsList = {onw: [], ret: []};
  let amenities = {};
  let single_seat = false;
  if (operators) {
    operators.forEach(item => {
      if (!rtcBuses[item.opid]) {
        const obj = {
          availableBuses: [],
          earliest_departure: '',
          fastest_duration: '',
          slowest_duration: '',
          busCount: 0,
          seatCount: 0,
          cheapest_price: 0,
          soldOutBuses: [],
        };

        rtcBuses[item.opid] = {
          img_url: item.image_url,
          opid: item.opid,
          name: item.name,
          onw: obj,
          ret: obj,
          f_name:item.f_name,
          msg: item?.msg
        };
      }
    });
  }
  const popularFilters = function(){
    let filters =[];
    for(const i in popular_filters){
      if(popular_filters.hasOwnProperty(i)){
        filters.push({
          index:i,
          k:popular_filters[i].k,
          v:popular_filters[i].v,
          activeIcon:popular_filters[i].activeIcon, 
          inactiveIcon:popular_filters[i].inactiveIcon,
          show: popular_filters[i].show
        })
      }
    }
    return filters;
      }()
  buses.forEach((bus, ind) => {
  
    let busOperator = null;
    let busBPList = null;
    let busDPList = null;
    bus.card_BPDP_Info =  {
      bp:Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp : [bus.fl[0].bp],
      dp:Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp]
    }
    const chooseBpDpFirst = bus.chooseBpDpFirst;
    const busSeatCount =   bus.fl[0].rd &&  bus.fl[0].rd.length &&  bus.fl[0].rd[0].SeatsAvailable ?  bus.fl[0].rd[0].SeatsAvailable:0;
    const price = bus.fd.tf;
    
    const duration = bus.fl[0].du;
    const operatorId = bus.fl[0].op;
    const departureTime = bus.fl[0].dt;
    amenities = getAmenties(bus.amenities, amenities);
    if (Object.keys(rtcBuses).length && operatorId && rtcBuses[operatorId]) {
      if (!rtcBuses[operatorId][journeyType].availableBuses.length) {
        rtcBuses[operatorId][journeyType].fastest_duration = duration;
        rtcBuses[operatorId][journeyType].cheapest_price = price;
        rtcBuses[operatorId][journeyType].slowest_duration = duration;
        rtcBuses[operatorId][journeyType].earliest_departure = departureTime;
      } else {
        const rtcFastestDuration = rtcBuses[operatorId][journeyType].fastest_duration
          ? rtcBuses[operatorId][journeyType].fastest_duration.split(' ')
          : [];
          const rtcSlowestDuration = rtcBuses[operatorId][journeyType].slowest_duration
          ? rtcBuses[operatorId][journeyType].slowest_duration.split(' ')
          : [];
        const busDurationTime = duration ? duration.split(' ') : [];
        const rtcDepartureTime = rtcBuses[operatorId][journeyType].earliest_departure
          ? rtcBuses[operatorId][journeyType].earliest_departure.split(':')
          : [];
        const earliest_departure = departureTime ? departureTime.split(':') : [];
        if (rtcFastestDuration && rtcFastestDuration.length && rtcFastestDuration.length > 1 && busDurationTime && busDurationTime.length >1) {
          const rtcMin = parseInt(rtcFastestDuration[1].replace(/m/g, ''), 10);
          const rtcDuration = parseFloat(
            `${rtcFastestDuration[0].replace(/h/g, '')}${rtcMin / 60}`,
          );
          const busMin = parseInt(busDurationTime[1].replace(/m/g, ''), 10);
          const busDuration = parseFloat(
            `${busDurationTime[0].replace(/h/g, '')}${busMin / 60}`,
          );

          if (busDuration < rtcDuration) {
            rtcBuses[operatorId][journeyType].fastest_duration = duration;
          } else {
            rtcBuses[operatorId][journeyType].slowest_duration = duration;
          }
        }

        if (rtcSlowestDuration && rtcSlowestDuration.length && rtcSlowestDuration.length > 1 && busDurationTime && busDurationTime.length >1) {
          const rtcMin = parseInt(rtcSlowestDuration[1].replace(/m/g, ''), 10);
          const rtcDuration = parseFloat(
            `${rtcSlowestDuration[0].replace(/h/g, '')}${rtcMin / 60}`,
          );
          const busMin = parseInt(busDurationTime[1].replace(/m/g, ''), 10);
          const busDuration = parseFloat(
            `${busDurationTime[0].replace(/h/g, '')}${busMin / 60}`,
          );

          if (busDuration > rtcDuration) {
            rtcBuses[operatorId][journeyType].slowest_duration = duration;
          }
        }

        if (
          rtcDepartureTime &&
          earliest_departure &&
          parseInt(rtcDepartureTime.join('')) > parseInt(earliest_departure.join(''))
        ) {
          rtcBuses[operatorId][journeyType].earliest_departure = departureTime;
        }
      }

      if (rtcBuses[operatorId][journeyType].cheapest_price > price) {
        rtcBuses[operatorId][journeyType].cheapest_price = price;
      }

      rtcBuses[operatorId][journeyType].seatCount += busSeatCount;
      rtcBuses[operatorId][journeyType].busCount += 1;
      if (busSeatCount) {
        busBPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp :[bus.fl[0].bp] ) : getBPList(bp_dict,operatorId);
        busDPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp])  : getDPList(dp_dict,operatorId);
        bus.fl[0].bp = busBPList;
        bus.fl[0].dp = busDPList;
        bus.filterHash = getFilterHash(bus,popularFilters);
 
        rtcBuses[operatorId][journeyType].availableBuses.push(Object.assign({},bus));
      } else {
        bus.filterHash = getFilterHash(bus,popularFilters);
 
        rtcBuses[operatorId][journeyType].soldOutBuses.push(bus);
      }
    } else {
      if (!busSeatCount) {
        bus.filterHash = getFilterHash(bus,popularFilters);
 
        privateSoldOutBuses[journeyType].push(Object.assign({},bus));
      } else {
        busBPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp :[bus.fl[0].bp] ) : getBPList(bp_dict,operatorId);
        busDPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp])  : getDPList(dp_dict,operatorId);
        bus.fl[0].bp = busBPList;
        bus.fl[0].dp = busDPList; 
        bus.filterHash = getFilterHash(bus,popularFilters);
        
        privateAvailableBuses[journeyType].push(Object.assign({},bus));
      }
    }
    busOperator = {id: bus.op, name: formatBusOperatorName(rtcBuses, bus)};

    if (busOperator && !operatorsList[journeyType].find(opItem => opItem.id === busOperator.id)) {
      operatorsList[journeyType].push(busOperator);
    }

    if (busBPList && busBPList.length > 0) {
      busBPList.forEach(bpItem => {
        const formattedBpItem = formatString(bpItem.BPN);
        if (!(bpList[journeyType].indexOf(formattedBpItem) > -1)) {
          bpList[journeyType].push(formattedBpItem);
        }
      });
    }

    if (busDPList && busDPList.length > 0) {
      busDPList.forEach(dpItem => {
        const formattedDpItem = formatString(dpItem.DPN);
        if (!(dpList[journeyType].indexOf(formattedDpItem) > -1)) {
          dpList[journeyType].push(formattedDpItem);
        }
      });
    }
  });

  amenities = getViewAmenties(amenities);
  const sortedAmenities = [amenities].sort(
    busSortComparator({sortType: 'string', sortKey: 'title'}),
  );
  amenities = sortedAmenities[0];
  for (let key in operatorsList) {
    if (operatorsList.hasOwnProperty(key)) {
      operatorsList[key].sort(busSortComparator({sortType: 'string', sortKey: 'name'}));
    }
  }
  for (let key in bpList) {
    if (bpList.hasOwnProperty(key)) {
      bpList[key].sort(sortByLowerCase);
    }
  }
  for (let key in dpList) {
    if (dpList.hasOwnProperty(key)) {
      dpList[key].sort(sortByLowerCase);
    }
  }
  return {
    rtcBuses,
    privateAvailableBuses,
    privateSoldOutBuses,
    dpList,
    bpList,
    operatorsList,
    amenities,
    popularFilters,
    single_seat,
    isRouteEnable:function(){
      let enable = false;
      // ["all-all"]
      // ["all-id"]
      // ["id-all"]
      // ["id-id"]
    
      if(route_logic && route_logic.length){
        for(let i in route_logic){
          const routeInfo = route_logic[i].split("-");
          const enabledSrc = routeInfo[0];
          const enabledDest = routeInfo[1];
          if(enabledSrc == "all" && enabledDest == "all"){
            enable = true;
            break;
          }
          if(enabledSrc == "all" && enabledDest == dest_id){
              enable = true;
              break;
          }
          if(enabledDest === "all" && enabledSrc == src_id){
            enable = true;
            break;
        }
        if(enabledSrc == src_id && enabledDest == dest_id){
          enable = true;
          break;
      }      
          
          }
    
        
    
        }
      
      return enable;
    }()
  };
}
function formatBusOperatorName(rtcList, item) {
  if (Object.keys(rtcList).indexOf(item.op) > -1) {
    return item.bid.split('/')[3];
  }
  return formatString(item.fl[0].cr);
}

/**
 * @description sorting comparator function for bus objects
 *
 * @param {obj} {sortType: String} e.g. - price, departureTime, duration, ratings
 * @returns conditinoal comparator function based on sortType passed
//  */
// best,
// rating:'rating_low/rating_high',
// departure:'early_departure/late_departure',
// arrival:'early_arrival/late_arrival',
// speed:'low_speed/high_spped'
// cheapest:'low_price/high_price'

function busSortComparator({sortType = '', sortKey = ''}) {
  return (itemA, itemB) => {
    let itemA_data = itemA;
    let itemB_data = itemB;
    let tempFlag;
    let res;
    if (sortType.indexOf('price') !== -1) {
      itemA_data = parseInt(itemA_data.fd.pp, 10);
      itemB_data = parseInt(itemB_data.fd.pp, 10);
      if (sortType === 'low_price') {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      }
    }
    if (sortType.indexOf('departure') !== -1) {
      itemA_data = itemA_data.fl[0].dt;
      itemB_data = itemB_data.fl[0].dt;
      if (sortType === 'early_departure') {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      }
    }
    if (sortType.indexOf('arrival') !== -1) {
      itemA_data = itemA_data.fl[0].at;
      itemB_data = itemB_data.fl[0].at;
      if (sortType === 'early_arrival') {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      }
    }

    if (sortType.indexOf('speed') !== -1) {
      const duArrA_data = itemA_data.fl[0].du.split(' ');
      if (duArrA_data && duArrA_data.length && duArrA_data.length > 1) {
        const minA = parseInt(duArrA_data[1].replace(/m/g, ''), 10);
        itemA_data = parseFloat(`${duArrA_data[0].replace(/h/g, '')}${minA / 60}`);
      }
      const duArrB_data = itemB_data.fl[0].du.split(' ');
      if (duArrB_data && duArrB_data.length && duArrB_data.length > 1) {
        const minB = parseInt(duArrB_data[1].replace(/m/g, ''), 10);
        itemB_data = parseFloat(`${duArrB_data[0].replace(/h/g, '')}${minB / 60}`);
      }
      if (sortType === 'high_speed') {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      }
    }
    if (sortType.indexOf('rating') !== -1) {
      itemA_data = parseFloat(itemA_data.fl[0].rating);
      itemB_data = parseFloat(itemB_data.fl[0].rating);
      if (sortType === 'rating_low') {
        tempFlag = itemA_data > itemB_data ? 1 : -1;
      } else {
        tempFlag = itemA_data < itemB_data ? 1 : -1;
      }
    }
    if (sortType === 'best') {
      itemA_data = parseFloat(itemA_data.bs);
      itemB_data = parseFloat(itemB_data.bs);
      tempFlag = itemA_data < itemB_data ? 1 : -1;
    }
    if (sortKey && sortType === 'string') {
      tempFlag = itemA_data[sortKey].toLowerCase() > itemB_data[sortKey].toLowerCase() ? 1 : -1;
    }

    res = itemA_data === itemB_data ? 0 : tempFlag;
    return res;
  };
}

//TODO:- icon Mapping function
function getAmenties(busAmenities: string[], amenities: {}) {
  if (busAmenities && busAmenities.length && busAmenities[0] !== 'NA') {
    for (const i in busAmenities) {
      if (busAmenities[i] && !amenities[busAmenities[i]]) {
        amenities[busAmenities[i]] = {title: busAmenities[i], icon: busAmenities[i]};
      }
    }
  }
  return amenities;
}
//const funcName:(no of arg with type)=>return type=(no of arguments with type)=>{func body}
const capitalize : (str:string,separator?: string) => string = (str: string, separator = ' ')=> {
  const strArr = str.toLowerCase().split(separator);
  for (const i in strArr) {
    strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
  }
  const r = strArr.join(separator);
  return r;
}

function getViewAmenties(amenities:any) {
  for (const key in amenities) {
    if (amenities.hasOwnProperty(key)) {
      const iconName = getIconName(amenities[key].icon) || '';

      amenities[key] = {title: (amenities[key].title), icon:iconName };
    }
  }

  return amenities;
}
function sortByLowerCase (a: any, b: any) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}

function getBPList(bp_dict,operatorId){
if(!bp_dict){
  return []
}
let list=[];
for (let bpName in bp_dict){
  if(bp_dict.hasOwnProperty(bpName) && bp_dict[bpName].indexOf(operatorId)!== -1){
   list.push({
    BPN:bpName
   })

  }
}
return list;
}
function getDPList(dp_dict,operatorId){
  if(!dp_dict){
    return []
  }
  let list=[];
  for (let dpName in dp_dict){
    if(dp_dict.hasOwnProperty(dpName) && dp_dict[dpName].indexOf(operatorId)!== -1){
     list.push({
      DPN:dpName
     })
  
    }
  }
  return list;
  }
  export const fetchSRPGoSafeBanner = (): ThunkAction<void, AppState, {}, AnyAction> => {
    return async(dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
      dispatch(updateGoSafeBanner({isLoading:true,isError:false,data:{}}))
    
      try {
        const url = prepareGoSafeBannerURL();
        const {data} = await megatron({
          name: 'GOSAFE API',
          type: 'GET',
          url,
        });
       if(data && data.slots && data.slots.bus_dweb_srp_gosafe_banner && data.slots.bus_dweb_srp_gosafe_banner.length)
      dispatch(updateGoSafeBanner({isLoading:false,isError:false,data:data.slots.bus_dweb_srp_gosafe_banner[0]}))
    
      } catch (e) {
  
        dispatch(updateGoSafeBanner({isLoading:false,isError:true,data:{}}))
    
        console.error('GOSAFE BANNER API Failed', e.error);
        console.trace(e);
      }
    
    }}  